<template>
  <div>
      <!-- Loading data -->
    <div class="loading-indicator" v-show="isLoading">
        <img src="static/images/link_inactive.svg" class="center-div spin-img ">
    </div>
    <!-- ----------ACTIVATE a CLA---------- -->
    <div id="activated_cla" v-show="user.data.admin" class="row content-block">

        <div class="row" style="margin-bottom: 65px; margin-top: 15px; padding-left:0px" v-show="!newLink">
            <button class="btn btn-info" @click="newLink = !newLink" style="font-size: 18px; font-weight: 200">Configure CLA</button>
        </div>
        <div class="row" v-show="newLink">
            <h4 class="col-xs-12" style="margin: 25px 0; padding-left: 0;">Configure CLA</h4>
        </div>

        <div class="well row" v-show="newLink" style="max-width:400px; position:relative;">
            <div @click="newLink = !newLink" class="fa fa-times close-button" style="position:absolute; right:20px"></div>
            <h5 v-if="!user.data.org_admin" class="col-xs-12 link-topic-2">
                <span class="link-topic-number">1</span>&nbsp;Choose a repository
                <span class="clickable" @click="addScopeVisible = true" style="font-size:12px; text-decoration:underline">(want to link an org?)</span>
            </h5>
            <h5 v-if="user.data.org_admin" class="col-xs-12 link-topic-2">
                <span class="link-topic-number">1</span>&nbsp;Choose an org or a repo
            </h5>
            <div class="col-xs-12">
                <div></div>
                <div class="form-group has-feedback">
                    <el-select v-model="selected.option" placeholder="请选择" style="width: 100%">
                      <el-option v-for="option in reposFilter" :key="option.full_name" :label="option.full_name" :value="option.id">
                          <span v-if="option.full_name" class="octicon" :class="option.fork?'octicon-repo-forked':'octicon-repo'" />
                          <span v-if="option.full_name">{{option.full_name}}</span>
                      </el-option>
                    </el-select>
                </div>
            </div>
            <h5 class="link-topic-1">
                <span class="link-topic-number">2</span>&nbsp;Choose a CLA
            </h5>
            <div class="col-xs-12">
                <!-- <div style="margin-bottom: 5px;">Select from Gist &nbsp;
                    <span class="clickable" @click="info()" style="font-size:12px; text-decoration:underline">(don't have one?)</span>
                </div> -->
                <div class="form-group has-feedback" style="margin-bottom: 10px;">
                    <el-select v-model="selected.gist" placeholder="请选择CLA协议" style="width: 100%">
                      <el-option
                        v-for="item in gists"
                        :key="item.name"
                        :label="item.name"
                        :value="item.url">
                      </el-option>
                    </el-select>
                </div>
                <div style="margin-bottom:10px">- or -</div>
                <div style="margin-bottom: 5px;">Paste a URL from a Gist</div>
                <el-input placeholder="https://gist.github.com/<your cla gist id>" v-model="selected.gist" :disabled="selected.gist.length>0"></el-input>
                <div style="margin-bottom: 15px; margin-top: 15px;">
                    <input type="checkbox" v-model="selected.sharedGist" :disabled="!selected.gist.length>0">&nbsp;Share the Gist
                    <span class="clickable" style="font-size:12px; text-decoration:underline">(want to share?)</span>
                </div>
            </div>

            <div v-for="error in errorMsg" class="alert alert-danger col-xs-12" role="alert" v-show="errorMsg.length > 0" :key="error">
                <span class="fa fa-warning" aria-hidden="true"></span>
                <span class="sr-only">Error:</span> {{ error }}
            </div>
        </div>
        <div class="row" style="max-width:400px; position:relative; margin-bottom: 65px;" v-show="newLink">
            <button class="btn btn-info col-xs-12" @click="link"  style="height: 45px">
                <img src="static/images/link_button.svg" style="height: 18px"> LINK
            </button>
        </div>

        <!-- ----------ACTIVATED REPOS---------- -->
        <div class="row">
            <h4 class="col-xs-12" style="margin: 25px 0; padding-left: 0;">Linked Repositories</h4>
        </div>
        <div class="well row" style="padding-top:25px;">
            <table class="table">
              <tbody>
                  <tr>
                      <td>
                          <div class="row">
                              <div class="col-sm-3 col-lg-2" style="padding-left:0">
                                  Repository
                              </div>
                              <div class="col-sm-3 col-lg-2">
                                  CLA
                              </div>
                              <div class="col-lg-2 hidden-xs hidden-sm hidden-md">
                                  Gist
                              </div>
                              <div class="col-sm-2 col-lg-2">
                                  Last updated
                              </div>
                              <div class="col-sm-1 col-lg-1">
                                  Shared Gist
                              </div>
                              <div class="col-sm-2 col-lg-1 text">
                                  Contributors
                              </div>
                              <div class="col-sm-1 col-lg-2">
                                  Status
                              </div>
                          </div>
                      </td>
                  </tr>
                  <tr v-for="(claRepo, index) in claRepos" :key="index">
                    <settings :item="claRepo" :gists="gists" @refresh="refresh"></settings>
                  </tr>
              </tbody>
            </table>
        </div>
    </div>  
    <el-dialog :visible.sync="addScopeVisible" title="Link Org" width="600px" center>
        <addScopeModel @close="addScopeVisible = false"></addScopeModel>
    </el-dialog>
  </div> 
</template>

<script>
import vSelect from 'vue-select'
import settings from './settings'
import addScopeModel from './../modal/addScope'
import {getGistAttribute} from '@/util/util' 
import {getUserFromGithub, getReposFromGithub, getLinkedReposFromGithub, 
        getDefaultClaFiles, getAllGists, createLinkedRepo} from '@/api/home'
export default {
  data() {
    return {
        addScopeVisible:false,
        isLoading:false,
        newLink: false,
        selected:{
            item:{},
            gist:'',
            sharedGist:false,
            option:''
        },
        user:{
            data:{
                admin: false,
                org_admin: false
            }
        },
        errorMsg:[],
        repos:[],
        gists: [],
        claRepos:[],
        defaultClas:[]
    };
  },
  components:{vSelect, settings, addScopeModel},
  created() {
    this._initHome()
  },
  methods: {
    _initHome() {
      this._getUser().then(() =>{
        Promise.all([this._getRepos()]).then(() =>{
          this.isLoading = false;
        },(err) =>{
          this.isLoading = false;
        })
      })
      this._getGists()
    },
    _getUser() {
        return getUserFromGithub().then((res) => {
            this.user = res;
            this.user.data.admin = res.meta.scopes && res.meta.scopes.indexOf('write:repo_hook') > -1 ? true : false;       // 这个是cla系统的管理员权限
            this.user.data.org_admin = res.meta.scopes && res.meta.scopes.indexOf('admin:org_hook') > -1 ? true : false;    // 这个是cla系统的管理员的管理Org的权限
            return       
        })
    },
    _getRepos() {
      return new Promise((resolve, reject) =>{
        if (this.user && this.user.data && this.user.data.admin) {
            getReposFromGithub().then((data) =>{
                data.data.forEach((repo) =>{
                    if (repo.permissions.push) {
                        this.repos.push(repo);
                    }
                });
                if (this.repos.length > 0) {
                    this.getLinkedRepos().then(() =>{
                      resolve()
                    })
                }else{
                  resolve()
                }       
            }).catch((err) =>{
              reject()
            })
        }
      })      
    },
    getLinkedRepos() {
      return new Promise((resolve, reject) =>{
        var repoSet = [];
        this.repos.forEach((repo) =>{
            repoSet.push({
                repoId: repo.id
            });
        });

        getLinkedReposFromGithub(repoSet).then((res) =>{
          this.claRepos = res
          this.claRepos.forEach((claRepo) =>{
              claRepo = this.mixRepoData(claRepo)
          });
          resolve()
        })
      })    
    },
    mixRepoData(claRepo) {
        this.repos.some((repo) =>{
            if (claRepo.repo === repo.name && claRepo.owner === repo.owner.login) {
                claRepo.fork = repo.fork;

                return true;
            }
        });

        return claRepo;
    },
    _getGists() {     
        if (!this.defaultClas.length) {
            getDefaultClaFiles().then((res) =>{
                this.defaultClas = res['default-cla'];
                this.gists = [].concat(this.defaultClas);
            })
        }

        getAllGists().then((res) =>{
            if (res && res.data) {
                res.data.forEach((gist) =>{
                    var gistFile = {};
                    gistFile.name = getGistAttribute(gist, 'filename');
                    gistFile.url = gist.html_url;
                    this.gists.push(gistFile);
                });
            }
        });
    },
    isRepo(item) {
        return item && (item.full_name || item.repoId) ? true : false;
    },
    isValid(gist) {
        var valid = false;
        valid = gist ? !!gist.match(/https:\/\/gist\.github\.com\/([a-zA-Z0-9_-]*)/) : false;
        return valid;
    },
    link() {
      let arr = this.repos
      this.selected.item = this.find(this.selected.option, arr)
      let options = {
        gist: this.selected.gist,
        sharedGist: this.selected.sharedGist,
        owner: this.selected.item.owner.login || this.selected.item.owner,
        repo: this.selected.item.repo || this.selected.item.name,
        repoId: this.selected.item.repoId || this.selected.item.id
      }

      createLinkedRepo(options).then((res) =>{
        let linkedItem = res;
        if (linkedItem) {
            this.mixRepoData(linkedItem);
            linkedItem.active = true;
            this.claRepos.push(linkedItem);
        } else {
            this.deleteFromArray(this.selected.item, this.claRepos);
        }
        this.$message('link succeed');
        this.newLink = false;
      }).catch((err) =>{
        if (err && err.message.match(/.*duplicate key error.*/)) {
            this.showErrorMessage('This repository is already set up.');
        } else if (err && err.message) {
            this.showErrorMessage(err.message);
        }
      })
    },
    find(item, arr) {
      return arr.find((a) =>{
        return a.id === item
      })
    },
    deleteFromArray(item, array) {
        let i = array.indexOf(item);
        if (i > -1) {
            array.splice(i, 1);
        }
    },
    showErrorMessage(text) {
        let error = text;
        setTimeout(() =>{
            deleteFromArray(error, this.errorMsg);
        }, 5000);

        this.errorMsg.push(error);
    },
    refresh(type){
      this.getLinkedRepos();
      this.$message('operation succeed');
    },
    itemInRepos(item, arr) {
      return arr.some((a) =>{
          return parseInt(a.repoId) === parseInt(item.id)
      })
    },
  },
  computed:{
    isComplete() {
        return this.selected.item && this.selected.gist && ((this.isRepo(this.selected.item) && (!this.selected.gist.url || this.isValid(this.selected.gist.url))) || (!this.isRepo(this.selected.item) && this.isValid(this.selected.gist.url)));
    },
    reposFilter() {
        return this.repos.filter((item) =>{
          return !this.itemInRepos(item, this.claRepos)
        })
    },
  },
}

</script>

<style>

</style>


// WEBPACK FOOTER //
// src/javascript/home/components/template/index.vue